import React, { useEffect, useState } from "react";
import {
  Row,
  Container,
  Image,
  Col,
  Form,
  Button,
  Tab,
  Nav,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  createKycApplicantStart,
  get2faDetailsStart,
  logoutStart,
  profileStart,
  profileUpdateStart,
} from "../../store/actions/UserAction";
import { connect, useDispatch, useSelector } from "react-redux";
import ProfileLoader from "../helper/ProfileLoader";
import KYCUpdateModal from "../KYC/KYCUpdateModal";
import { useTranslation } from "react-multi-lang";
import { Uploader } from "uploader";
import { UploadButton } from "react-uploader";
import EditProfileModal from "../Modals/EditProfileModal";
import { Checkbox, Switch } from "pretty-checkbox-react";
import "@djthoms/pretty-checkbox";
import ChangePasswordModal from "../Modals/ChangePasswordModal";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import EditAddressModal from "../Modals/EditAddressModal";
import ChangeMobileNumberModal from "../Modals/ChangeMobileNumberModal";
import CustomLazyLoad from "../helper/CustomLazyLoad";
import LogoutModal from "../Modals/LogoutModal";
import DeleteAccountModal from "../Modals/DeleteAccountModal";
import ChangeProfileImageModal from "../Modals/ChangeProfileImageModal";
import useLogout from "../layouts/Header/useLogout";
import EnableDisableTwoStepAuth from "../Auth/EnableDisableTwoStepAuth";
import { countryData } from "../helper/CountryList";
import "../Profile/Profile.css";
import CommonCenterLoader from "../helper/CommonCenterLoader";

const KYCIndex = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);
  const [sdkKeyModal, setSdkKeyModal] = useState(false);
  const [editModal, setEditShow] = useState(false);
  const [addressModal, setAddressModal] = useState(false);
  const [changeMobileNumber, setchangeMobileNumber] = useState(false);
  const [twoStepAuthModal, setTwoStepAuthModal] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState();
  const [changeProfileImage, setChangeProfileImage] = useState(false);
  const [logoutShow, setLogoutShow] = useState(false);
  const [activateEuroShow, setActivateEuroShow] = useState(false);
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [verified, setVerified] = useState(false);

  const profile = useSelector((state) => state.user.profile);
  const [activeKey, setActiveKey] = useState("first");
  const logout = useSelector((state) => state.user.logout);

  const uploader = Uploader({
    apiKey: "free",
  });

  const options = {
    multi: false,
    mimeTypes: ["image/jpeg", "image/png", "image/jpg"],
  };
  const t = useTranslation("profile");
  const [kyc, setKyc] = useState(false);
  const [skipRender, setSkipRender] = useState(true);

  const closeKycModal = () => {
    setKyc(false);
  };
  useEffect(() => {
    if (
      !skipRender &&
      !props.kycStatusUpdate.loading &&
      Object.keys(props.kycStatusUpdate.data).length > 0
    ) {
      closeKycModal();
    }
    setSkipRender(false);
  }, [props.kycStatusUpdate]);

  const verifyKyc = () => {
    props.dispatch(createKycApplicantStart());
  };

  useEffect(() => {
    if (
      !skipRender &&
      !props.kycApplicant.loading &&
      Object.keys(props.kycApplicant.data).length > 0
    ) {
      setKyc(props.kycApplicant.data);
    }
    setSkipRender(false);
  }, [props.kycApplicant]);

  useEffect(() => {
    if (
      !skipRender &&
      !props.updateProfile.loading &&
      Object.keys(props.updateProfile.data).length > 0
    ) {
      setEditShow(false);
      setAddressModal(false);
    }
  }, [props.updateProfile]);

  useEffect(() => {
    if (!profile.loading && Object.keys(profile.data).length > 0) {
      //   setIsSwitchOn(profile.data.is_2fa_enabled == 1);
      // console.log(profile.data.sumsub_token, "Kyc Index")
      if(profile.data.kyc_verified){
        setVerified(true)  
      } else {
        setKyc(true);
      }
    }
  }, [profile]);

  useEffect(() => {
    if (
      !skipRender &&
      !props.changePassword.loading &&
      Object.keys(props.changePassword.data).length > 0
    ) {
      props.dispatch(logoutStart());
    }
    setSkipRender(false);
  }, [props.changePassword]);

  useEffect(() => {
    if (!skipRender && !logout.loading && Object.keys(logout.data).length > 0) {
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem("lang", "en");
      navigate("/login");
    }
    setSkipRender(false);
  }, [logout]);

  const toggleTFA = () => {
    setIsSwitchOn(!isSwitchOn);
    setTwoStepAuthModal(true);
  };

  return (
    <>
      {props.profile.loading ? (
        <CommonCenterLoader />
      ) : (
        <div className="feature-profile-wrapped">
          <Row>
            <Col
              sm={12}
              lg={6}
              xl={6}
              className="resp-marg-btm-xs"
              style={{ margin: "auto", display: "flex" }}
            >
              <div className="feature-primary-profile-card">
                <div className="feature-primary-profile-input">
                  <div className="feature-primary-profile-dp">
                    {props.updateProfile.buttonDisable ? (
                      <Skeleton circle={true} height={100} width={100} />
                    ) : (
                      <CustomLazyLoad
                        className="user profile-image"
                        src={
                          props.profile.data.picture ||
                          window.location.origin + "/img/icon/user.png"
                        }
                        type="image/png"
                      />
                    )}
                  </div>
                  {/* </UploadButton> */}
                </div>
                <div className="feature-primary-profile-info">
                  <h3>
                    {props.profile.data.first_name}{" "}
                    {props.profile.data.middle_name}{" "}
                    {props.profile.data.last_name}
                  </h3>
                </div>
                <div className="feature-primary-profile-details">
                  <h4>{t("email.label")}</h4>
                  <p>{props.profile.data.email}</p>
                </div>
               {verified ? <div className="feature-profile-action">
                  <div className="edit-profile-note-info-sec">
                    <Button className="finger-print-btn">
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="none"
                        viewBox="0 0 35 35"
                        >
                        <path
                            fill="#51C8AC"
                            d="M21.328 15.953v-.51c0-3.336-2.453-6.183-5.585-6.482a6.187 6.187 0 00-5.572 2.45 1.092 1.092 0 11-1.749-1.313c1.77-2.356 4.573-3.595 7.528-3.314 4.197.4 7.483 4.13 7.553 8.52-.757.139-1.486.354-2.175.65zM3.464 21.431c.603 0 1.093-.49 1.093-1.094V15.53c0-5.782 4.334-10.592 9.867-10.95a10.61 10.61 0 015.992 1.39 1.091 1.091 0 001.494-.398 1.092 1.092 0 00-.399-1.494 12.752 12.752 0 00-7.228-1.681C7.603 2.83 2.37 8.598 2.37 15.53v4.807c0 .604.49 1.094 1.093 1.094zm4.374-7.395c-.603 0-1.093.49-1.093 1.094v8.75a9.882 9.882 0 004.92 8.527 1.094 1.094 0 101.095-1.894 7.685 7.685 0 01-3.828-6.633v-8.75c0-.604-.49-1.094-1.094-1.094zm11.303 3.21v-1.96c0-2.035-1.439-3.802-3.346-4.112a4.034 4.034 0 00-3.262.9 4.006 4.006 0 00-1.413 3.056v5.833c0 4.822 2.689 9.025 6.644 11.195a10.165 10.165 0 01-2.47-5.048 10.502 10.502 0 01-1.987-6.146V15.13c0-.535.234-1.042.643-1.39a1.812 1.812 0 011.495-.407c.86.14 1.508.979 1.508 1.953v4.246a10.28 10.28 0 012.188-2.286zm5.148-7.402a10.57 10.57 0 011.414 5.286v.018c.753.027 1.484.136 2.188.318v-.336c0-2.243-.59-4.449-1.708-6.38a1.095 1.095 0 00-1.894 1.094z"
                        ></path>
                        <path
                            fill="#1AA080"
                            d="M25.338 18.047a7.292 7.292 0 100 14.583 7.292 7.292 0 000-14.583zm3.433 5.862l-3.889 3.89a.729.729 0 01-1.031 0l-1.945-1.945a.729.729 0 111.031-1.031l1.43 1.429 3.373-3.374a.729.729 0 111.03 1.031z"
                        ></path>
                        </svg>
                        {t("kyc_verified")}
                    </Button>
                  </div>
                </div> : null}
                <div className="feature-profile-action">
                  <div className="edit-profile-note-info-sec">
                    <Button
                      onClick={() => {
                        dispatch(logoutStart());
                      }}
                      className="action-btn "
                      disabled={logout.buttonDisable}
                    >
                      {logout.buttonDisable ? t("loading") : "Logout"}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      )}
      {kyc ? <KYCUpdateModal kyc={kyc} closeKyc={closeKycModal} /> : null}
    </>
  );
};

const mapStateToPros = (state) => ({
  profile: state.user.profile,
  kycStatusUpdate: state.user.updateKYC,
  kycApplicant: state.user.kycApplicant,
  updateProfile: state.user.updateProfile,
  changePassword: state.user.changePassword,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}
export default connect(mapStateToPros, mapDispatchToProps)(KYCIndex);
